import { getIsActive } from '@core/functions/get-is-active';
import {
    U2bColumnDefinitionBrakePoint,
    U2bColumnPipeName,
    U2bTableData,
    U2bTableTextAlignments,
} from '@core/components/layout/table/table.types';
import { FilterFieldType } from '@core/datafilter/available-filter-fields';
import { FILTER_OPERATORS_DEFAULT_NUMERIC } from '@core/datafilter/constants';
import { BcmUserTableSettingKey } from '@shared/models/bcm-settings-user';
import { BcmDepartment } from '@shared/models/bcm-department';

export const departmentsTableData: U2bTableData = {
    tableId: BcmUserTableSettingKey.Departments,
    hasServerSideFiltering: true,
    columnDefinitions: [
        {
            property: 'name',
            name: 'Name',
            isActive: getIsActive(true),
            translationKey: 'table.name',
            exportKey: 'name',
            filter: {},
        },
        {
            property: 'headDisplayName',
            name: 'Leitung',
            isActive: getIsActive(true),
            translationKey: 'bcmDepartments.table.head',
            exportKey: 'headDisplayName',
            parseItem: (item: BcmDepartment) => item.headDisplayName || '',
            filter: {},
        },
        {
            property: 'description',
            name: 'Beschreibung',
            isActive: getIsActive(true),
            translationKey: 'table.description',
            exportKey: 'description',
            filter: {},
        },
        {
            property: 'costCentersSummary',
            name: 'Kostenstelle',
            isActive: getIsActive(true),
            translationKey: 'bcmDepartments.table.costCenters',
            exportKey: 'costCentersSummary',
            parseItem: (item: BcmDepartment) => item.costCentersSummary || '',
            filter: {},
        },
        {
            property: 'employeeCount',
            name: 'Mitarbeiter',
            isActive: getIsActive(true),
            translationKey: 'bcmDepartments.table.employees',
            exportKey: 'employeeCount',
            parseItem: (item: BcmDepartment) => item.employeeCount ?? 0,
            pipe: U2bColumnPipeName.Number,
            alignment: {
                [U2bColumnDefinitionBrakePoint.Desktop]: U2bTableTextAlignments.Right,
                [U2bColumnDefinitionBrakePoint.Tablet]: U2bTableTextAlignments.Right,
                [U2bColumnDefinitionBrakePoint.Mobile]: U2bTableTextAlignments.Right,
            },
            filter: {
                fieldType: FilterFieldType.Numeric,
                operators: FILTER_OPERATORS_DEFAULT_NUMERIC,
            },
        },
    ],
};
